import { render, staticRenderFns } from "./refrigerator.vue?vue&type=template&id=6cd3fc3e&scoped=true&"
import script from "./refrigerator.vue?vue&type=script&lang=js&"
export * from "./refrigerator.vue?vue&type=script&lang=js&"
import style0 from "./refrigerator.vue?vue&type=style&index=0&id=6cd3fc3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd3fc3e",
  null
  
)

export default component.exports